import React, { useState, useEffect } from 'react';
import AmPermissionsView from '../components/AmPermissionsView.jsx';
import { compose } from 'modules/core';
import { withApollo } from '@apollo/client/react/hoc';
import { getIntFromString } from 'modules/look/components/functions';
import { useLazyQuery, useMutation } from '@apollo/client';
import { ORG_PERMISSIONS_QUERY, GET_ALL_GROUPS_QUERY, UPDATE_ORG_PERMISSIONS_MUTATION } from '../graphql/am-permission-queries.gql';
import { ORGANIZATION_BY_ID_QUERY_OPTIMIZED } from '../graphql/OrganizationByIdForAm.gql.js';
import { getOrgID } from 'modules/poc-dashboard/containers/organization/organizationOperations';

const AmPermissionsContainer = (props) => {
  const orgIdBase64 = getOrgID(props) || props.orgToFetchData?.id;
  const orgId = getIntFromString(orgIdBase64);

  // Get user's employee id
  const userEmployeeId = props.me?.employee?.id;

  // Fetch org employees
  const [fetchOrgEmployees, { data: orgData }] = useLazyQuery(ORGANIZATION_BY_ID_QUERY_OPTIMIZED, {
    variables: { id: orgIdBase64 },
    fetchPolicy: 'network-only',
  });

  const [fetchPermissions, { data: permissionsData, loading: permissionsLoading, error: permissionsError }] = useLazyQuery(ORG_PERMISSIONS_QUERY, {
    variables: { id: orgIdBase64 },
    fetchPolicy: 'no-cache',
  });

  const [fetchAllGroups, { data: allGroupsData, loading: allGroupsLoading, error: allGroupsError }] = useLazyQuery(GET_ALL_GROUPS_QUERY);

  const [selectedGroupIds, setSelectedGroupIds] = useState([]);

  useEffect(() => {
    if (permissionsData?.organizationById?.permgroups?.edges) {
      setSelectedGroupIds(permissionsData.organizationById.permgroups.edges.map(edge => edge.node.id));
    }
  }, [permissionsData]);

  useEffect(() => {
    if (orgIdBase64) fetchPermissions();
    fetchAllGroups();
    // eslint-disable-next-line
  }, [orgIdBase64]);

  useEffect(() => {
    if (orgIdBase64) fetchOrgEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgIdBase64]);

  useEffect(() => {
    if (orgData && orgData.organizationById) {
    }
  }, [orgData, orgIdBase64]);

  // Check if user is employee of this org
  let isAmOfOrg = false;
  if (orgData && orgData.organizationById && orgData.organizationById.employees) {
    const orgEmployeeIds = orgData.organizationById.employees.edges.map(edge => edge.node.id);
    isAmOfOrg = orgEmployeeIds.includes(userEmployeeId);
  }

  const [updatePermissions, { loading: updateLoading }] = useMutation(UPDATE_ORG_PERMISSIONS_MUTATION, {
    onCompleted: () => {
      fetchPermissions();
      fetchAllGroups();
    }
  });

  const handleToggle = (groupId) => {
    setSelectedGroupIds(prev =>
      prev.includes(groupId)
        ? prev.filter(id => id !== groupId)
        : [...prev, groupId]
    );
  };

  const handleUpdate = (groupIds) => {
    const intGroupIds = groupIds.map(getIntFromString);
    updatePermissions({ variables: { id: orgId, permgroups: intGroupIds } });
  };
  return (
    <AmPermissionsView
      {...props}
      orgId={orgIdBase64}
      orgData={orgData}
      permissionsData={permissionsData}
      permissionsLoading={permissionsLoading}
      permissionsError={permissionsError}
      fetchPermissions={fetchPermissions}
      allGroupsData={allGroupsData}
      allGroupsLoading={allGroupsLoading}
      allGroupsError={allGroupsError}
      fetchAllGroups={fetchAllGroups}
      selectedGroupIds={selectedGroupIds}
      onToggleGroup={handleToggle}
      onUpdate={handleUpdate}
      updateLoading={updateLoading}
      isAmOfOrg={isAmOfOrg}
    />
  );
};

export default compose(withApollo)(AmPermissionsContainer);